const sortList = [
  {"option": "Last Accessed"},
  {"option": "Due Date"},
  {"option": "Status"},
  {"option": "Title"}
];

export default sortList;
